import { render, staticRenderFns } from "./homefire-policy-form.vue?vue&type=template&id=65710bfd&scoped=true&"
import script from "./homefire-policy-form.vue?vue&type=script&lang=js&"
export * from "./homefire-policy-form.vue?vue&type=script&lang=js&"
import style0 from "./homefire-policy-form.vue?vue&type=style&index=0&id=65710bfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65710bfd",
  null
  
)

export default component.exports